/**
 * /teacher/approvals moved: a teacher's approvals are a tab of My Classes, and
 * a principal decides on students in the school's Students tab.
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const StudentApprovalsRedirect = () => {
  const { profile } = useAuth();
  const to = profile?.role === 'teacher' ? '/admin/classes?tab=approvals' : '/admin/classes?tab=students&filter=pending';
  return <Navigate to={to} replace />;
};

export default StudentApprovalsRedirect;
